import ContactInfo from '../ContactInfo';
import type { ColumnType } from '../../../components';

export const contactColumn: ColumnType<Record<any, any>> = Object.freeze({
  header: 'Contact',
  sortName: 'contact_email',
  cellClassName: 'text-small min-w-[20rem]',
  getValue: contact => (
    <ContactInfo
      contact={{
        ...contact,
        last_name: '',
        id: contact.contact_id,
        phone: contact.contact_phone,
        email: contact.contact_email,
        first_name: contact.contact_name,
      }}
      withMessagesLink
    />
  ),
});
